define('core/bus',[
    'backbone',
    'underscore',

    'core/frameBus',
], function (
    Backbone,
    _,

    frameBus
) {
    'use strict';

    var bus = _.extend({}, Backbone.Events);
    bus.frame = frameBus;

    return bus;
});

